import { ChevronIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import styled from 'styled-components';

const HeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  ${({ open }) => open && `box-shadow: 0px 2px 4px 0px rgba(14, 20, 29, 0.15);`}
  h2 {
    font-size: 18px;
    line-height: 21px;
    font-weight: 600;
    color: #2d1441;
    margin-bottom: 3px;
    user-select: none;
  }
  p {
    font-family: 'cerapro';
    color: #2d1441;
    font-size: 16px;
    line-height: 19px;
    user-select: none;
    font-weight: 400;
  }
`;

const TagContainer = styled.div`
  display: flex;
  align-items: center;
`;

const colorBackground = props => {
  if (props.code === 'warning') return '#ff8723'; // por vencer
  if (props.code === 'paid') return '#33CC9E'; // pagada
  if (props.code === 'not_paid') return '#FD3A4A'; // vencida
  if (props.code === 'created') return '#7C6C8A'; // emitida
  return '';
};

const TagDeuda = styled.span`
  margin-left: 8px;
  display: inline-block;
  padding: 2px 9px;
  background: ${colorBackground};
  border-radius: 44px;
  color: #ffffff;
  font-size: 10px;
  line-height: 16px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 700;
  white-space: nowrap;
`;

const ChevronIconStyled = styled(ChevronIcon)`
  flex-shrink: 0;
  ${({ open }) => open && `transform: rotate(-180deg);`}
`;

export { HeadingContainer, TagDeuda, TagContainer, ChevronIconStyled };
